import React from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Input from "../../../Components/Control/Input";
import Separator from "../../../Components/Control/Separator";
import './index.css';
import Label from "../../../Components/Control/Label";
import Check from "../../../Components/Control/Check";
import Printer from "../../../Printer";
import Resource from "../../../Resource";
import {updateBase} from "../../../Redux/Actions/base";
import App from "../../../App";
import MyComponent from '../../../Components/MyComponent';

class ModalPrint extends MyComponent {
    constructor (props) {
        super(props);
        props.refer.current = this;

        this.state = {
            error: false,
            loading: false,
            fields: [],
            printerList: [],
            buttonsLoading: []
        };

        this.ref = {
            modal: React.createRef(),
            print: React.createRef(),
            close: React.createRef()
        };

        this.printer = null;
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func
    };

    static validations = {};

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.printOnPrepare !== nextState.printOnPrepare ||
            state.printerList !== nextState.printerList ||
            state.buttonsLoading !== nextState.buttonsLoading ||
            state.checkPrompt !== nextState.checkPrompt;
    }

    componentDidMount () {

    }

    render () {
        const {state} = this;

        const restOfPrints = [...(state?.data?.prints || [])];
        const firstOfPrints = restOfPrints.shift();

        return <Modal ref={this.ref.modal}
                      name={`ModalPrint`}
                      className={this.state.error ? 'error' : ''}
                      size={'small'}
                      loading={state.loading}
                      title={state?.data?.title || 'چاپ'}>
            <ModalContent>
                {firstOfPrints && <div className={'dis-f'}>
                    <Label className={'flex'}>{firstOfPrints.title}</Label>
                    <Check label={'نمایش تنظیمات قبل از چاپ'} checked={state?.fields[0]?.settingsPreview} onChange={this.setField.bind(this, 'settingsPreview', 0)}/>
                    <Select className={'pad-4 fb-20'} options={state.printerList} value={state?.fields[0]?.printerName} onChange={this.setField.bind(this, 'printerName', 0)}/>
                    <button className={'ModalPrint-button inc-dic'} onClick={this.countManipulateHandler.bind(this, 0, 'inc')}>+</button>
                    <Input type={"number"} className={'ModalPrint-input pad-4'} align={'center'} direction={"ltr"} value={state?.fields[0]?.count || 0} style={{width: 50}} onBlur={this.countChangeHandler.bind(this, 0)}/>
                    <button className={'ModalPrint-button inc-dic'} onClick={this.countManipulateHandler.bind(this, 0, 'dec')}>-</button>
                    <div className="flex"/>
                    <button className={`ModalPrint-button preview ${state.buttonsLoading[0] ? 'loading' : ''}`} disabled={state.buttonsLoading[0]} onClick={this.preview.bind(this, 0)}>پیش نمایش</button>
                    {restOfPrints.length > 0 && <button className={`ModalPrint-button print ${state.buttonsLoading[0] ? 'loading' : ''}`} disabled={state.buttonsLoading[0]} onClick={this.print.bind(this, 0)}>چاپ</button>}
                </div>}
                {restOfPrints.map((item, index) => {
                    return <React.Fragment key={index}>
                        <Separator/>
                        <div className={'dis-f'}>
                            <Label className={'flex'} size={'medium'}>{item.title}</Label>
                            <Check label={'نمایش تنظیمات قبل از چاپ'} checked={state?.fields[index + 1]?.settingsPreview} onChange={this.setField.bind(this, 'settingsPreview', index + 1)}/>
                            <Select className={'pad-4 fb-20'} options={state.printerList} value={state?.fields[index + 1]?.printerName} onChange={this.setField.bind(this, 'printerName', index + 1)}/>
                            <button className={'ModalPrint-button inc-dic'} onClick={this.countManipulateHandler.bind(this, index + 1, 'inc')}>+</button>
                            <Input type={"number"} className={'ModalPrint-input pad-4'} align={'center'} direction={"ltr"} value={state?.fields[index + 1]?.count || 0} style={{width: 50}} onBlur={this.countChangeHandler.bind(this, index + 1)}/>
                            <button className={'ModalPrint-button inc-dic'} onClick={this.countManipulateHandler.bind(this, index + 1, 'dec')}>-</button>
                            <div className="flex"/>
                            <button className={`ModalPrint-button preview ${state.buttonsLoading[index + 1] ? 'loading' : ''}`} disabled={state.buttonsLoading[index + 1]} onClick={this.preview.bind(this, index + 1)}>پیش‌نمایش</button>
                            <button className={`ModalPrint-button print ${state.buttonsLoading[index + 1] ? 'loading' : ''}`} disabled={state.buttonsLoading[index + 1]} onClick={this.print.bind(this, index + 1)}>چاپ</button>
                        </div>
                    </React.Fragment>;
                })}
                {state.error && <div className={'error-prompt'}>
                    <p>ارتباط با پرینتر دچار مشکل شده است. لطفا مطمئن شوید که برنامه در حال اجرا باشد و یا در صورتی که نسخه نصب شده برنامه را ندارید از قسمت پایین آن را دانلود و نصب کنید.</p>
                    <p style={{fontSize: 20, fontWeight: '500'}}>{state.checkPrompt}</p>
                </div>}
            </ModalContent>
            <ModalControls>
                {state.error ?
                    <React.Fragment>
                        <Button refer={this.ref.connect} className={'mar-4'} onClick={this.download.bind(this)} icon={Resource.IMAGE.PACK.DOWNLOAD1.WHITE}>دانلود فایل نصب</Button>
                        <Button refer={this.ref.connect} className={'mar-4'} onClick={this.connect.bind(this)}>اتصال دوباره</Button>
                    </React.Fragment> :
                    <React.Fragment>
                        <Button refer={this.ref.print} className={'mar-4'} onClick={this.print.bind(this, null)} theme={'blue'}>چاپ</Button>
                        <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)} theme={'blue'}>بستن</Button>
                    </React.Fragment>}
            </ModalControls>
        </Modal>;
    }

    setField (key, index, value) {
        const fields = [...this.state.fields];

        fields[index][key] = value;

        this.setState({fields});
    }

    countChangeHandler (index, count) {
        const fields = [...this.state.fields];

        if (!(count && parseInt(count) >= 0)) {
            count = 0;
        }

        fields[index].count = parseInt(count);

        this.setState({fields});
    }

    countManipulateHandler (index, dir) {
        const fields = [...this.state.fields];

        if (dir === 'inc') {
            fields[index].count += 1;
        } else if (dir === 'dec') {
            fields[index].count -= 1;

            if (fields[index].count < 0) {
                fields[index].count = 0;
            }
        }

        this.setState({fields});
    }

    open (data) {
        this.setState({
            data,
            error: false,
            loading: true,
            fields: (data?.prints || []).map(item => {
                const saved = (this.props.base?.printerConfigurations || {})[item.id];

                return {
                    id: item.id,
                    count: saved?.count !== undefined ? saved?.count : (item.count || 0),
                    printerName: null,
                    template: item.template,
                    printPreview: (saved?.printPreview !== undefined ? saved?.printPreview : item.printPreview) || false,
                    settingsPreview: (saved?.settingsPreview !== undefined ? saved?.settingsPreview : item.settingsPreview) || false,
                    parameters: item.parameters,
                    datatables: item.datatables
                };
            }),
            buttonsLoading: (data?.prints || []).map(item => false)
        });

        this.connect();

        this.ref.modal.current.open()
            .then(_ => {
                this.ref.print.current.focus();
            });
    }

    close () {
        this.ref.modal.current.close();

        this.setState({fields: {}});

        this.props.onClose();
    }

    download () {
        window.open(Resource.EXE.PRINTER);
    }

    connect () {
        const props = {};

        this.setState({
            error: false,
            loading: true
        });

        if (this.props.base.printer_port) {
            props.port = this.props.base.printer_port;
        }

        this.printer = new Printer();
        this.printer.init({
            ...props,
            onConnect: _ => {
            },
            onDisconnect: _ => {
                this.setState({
                    loading: false,
                    error: true
                });
                this.checkConnection(window.ENV.PRINTER_SW_PORT);
            },
            onError: _ => {
                this.setState({
                    loading: false,
                    error: true
                });
                this.checkConnection(window.ENV.PRINTER_SW_PORT);
            },
            onPrinterListChange: list => {
                this.setState({
                    loading: false,
                    error: false,
                    printerList: list,
                    fields: this.state.fields.map(item => {
                        const saved = (this.props.base?.printerConfigurations || {})[item.id];
                        let printerName = [{id: list[0], text: list[0]}];

                        if (saved?.printerName) {
                            printerName = [{id: saved?.printerName, text: saved?.printerName}];
                        } else if (item.printerName) {
                            printerName = [{id: item.printerName, text: item.printerName}];
                        }

                        return {
                            ...item,
                            printerName
                        };
                    })
                });
            }
        });
    }

    print (index) {
        // if parameters is an array so print separately
        const data = [];
        let fields = [...this.state.fields];

        if (index !== null) {
            fields = fields.splice(index, 1);
        }

        for (let item of fields) {
            if (Array.isArray(item.parameters) &&
                Array.isArray(item.datatables) &&
                item.parameters.length === item.datatables.length) {
                for (let index in item.parameters) {
                    data.push({
                        printerName: item.printerName[0].id,
                        count: item.count,
                        settingsPreview: item.settingsPreview,
                        printPreview: false,
                        template: item.template,
                        parameters: item.parameters[index],
                        datatables: item.datatables[index]
                    });
                }
            } else if (Array.isArray(item.parameters)) {
                for (let params of item.parameters) {
                    data.push({
                        printerName: item.printerName[0].id,
                        count: item.count,
                        settingsPreview: item.settingsPreview,
                        printPreview: false,
                        template: item.template,
                        parameters: params,
                        datatables: item.datatables || null
                    });
                }
            } else if (Array.isArray(item.datatables)) {
                for (let datatable of item.datatables) {
                    data.push({
                        printerName: item.printerName[0].id,
                        count: item.count,
                        settingsPreview: item.settingsPreview,
                        printPreview: false,
                        template: item.template,
                        parameters: item.parameters || null,
                        datatables: datatable
                    });
                }
            } else {
                data.push({
                    printerName: item.printerName[0].id,
                    count: item.count,
                    settingsPreview: item.settingsPreview,
                    printPreview: false,
                    template: item.template,
                    parameters: item.parameters || null,
                    datatables: item.datatables || null
                });
            }
        }

        this.saveToBrowser(data);

        if (index === null) {
            this.ref.print.current.loading();
        } else {
            const buttons = [...this.state.buttonsLoading];
            buttons[index] = true;

            this.setState({buttonsLoading: buttons});
        }

        App.log('Printer', App.LOG.PRINT, data);

        this.printer.print(data)
            .then(_ => {
                try {
                    this.ref.print.current.loading(false);
                    this.ref.modal.current.close();
                } catch (e) {
                }
            })
            .catch(_ => {
                try {
                    this.ref.print.current.loading(false);
                    this.setState({error: true});
                } catch (e) {
                }
            });
    }

    preview (index) {
        const data = [];
        const item = {...this.state.fields[index]};

        if (Array.isArray(item.parameters) &&
            Array.isArray(item.datatables) &&
            item.parameters.length === item.datatables.length) {
            for (let index in item.parameters) {
                data.push({
                    printerName: item.printerName[0].id,
                    count: item.count,
                    settingsPreview: item.settingsPreview,
                    printPreview: true,
                    template: item.template,
                    parameters: item.parameters[index],
                    datatables: item.datatables[index]
                });
            }
        } else if (Array.isArray(item.parameters)) {
            for (let params of item.parameters) {
                data.push({
                    printerName: item.printerName[0].id,
                    count: item.count,
                    settingsPreview: item.settingsPreview,
                    printPreview: true,
                    template: item.template,
                    parameters: params,
                    datatables: item.datatables || null
                });
            }
        } else if (Array.isArray(item.datatables)) {
            for (let datatable of item.datatables) {
                data.push({
                    printerName: item.printerName[0].id,
                    count: item.count,
                    settingsPreview: item.settingsPreview,
                    printPreview: true,
                    template: item.template,
                    parameters: item.parameters || null,
                    datatables: datatable
                });
            }
        } else {
            data.push({
                printerName: item.printerName[0].id,
                count: item.count,
                settingsPreview: item.settingsPreview,
                printPreview: true,
                template: item.template,
                parameters: item.parameters || null,
                datatables: item.datatables || null
            });
        }

        this.saveToBrowser(data);

        const buttons = [...this.state.buttonsLoading];
        buttons[index] = true;
        this.setState({buttonsLoading: buttons});

        if (window.ENV.DEBUG_MOOD)
            App.log('Printer', App.LOG.PRINT, data);

        this.printer.print(data)
            .then(_ => {
                try {
                    const buttons = [...this.state.buttonsLoading];
                    buttons[index] = false;
                    this.setState({buttonsLoading: buttons});
                } catch (e) {
                }
            })
            .catch(_ => {
                try {
                    this.ref.print.current.loading(false);
                    const buttons = [...this.state.buttonsLoading];
                    buttons[index] = false;
                    this.setState({error: true, buttonsLoading: buttons});
                } catch (e) {
                }
            });
    }

    saveToBrowser (data) {
        const list = {...this.props.base.printerConfigurations};

        for (let item of this.state.fields) {
            list[item.id] = {
                id: item.id,
                count: item.count,
                printerName: item.printerName[0].id,
                settingsPreview: item.settingsPreview
            };
        }

        this.props.updateBase({
            printerConfigurations: list
        });
    }

    checkConnection (port) {
        console.log(port);
        if (port - parseInt(window.ENV.PRINTER_SW_PORT) <= 10)
            this.setState({
                checkPrompt: `در حال بررسی پورت‌ ${port}`
            });
        else {
            this.setState({
                checkPrompt: 'پورت مورد نظر پیدا نشد.'
            });
            return;
        }

        this.printer = new Printer();
        this.printer.init({
            port,
            onConnect: _ => {
            },
            onDisconnect: _ => {
                this.checkConnection(++port);
            },
            onError: _ => {
                this.checkConnection(++port);
            },
            onPrinterListChange: list => {
                this.props.updateBase({
                    printer_port: port
                });

                this.connect();
            }
        });
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalPrint);